import * as React from "react";

const SVGComponent = (props) => (
  <svg
    width="87.977547mm"
    height="22.095407mm"
    viewBox="0 0 87.977547 22.095407"
    id="svg11133"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs id="defs11130" />
    <g id="layer1" transform="translate(130.82351,33.700247)">
      <path
        fillRule="nonzero"
        fill="#c31d24"
        fillOpacity={1}
        d="m -122.08454,-33.616242 c -4.73632,0 -8.57553,4.477247 -8.57553,9.997665 0,5.521801 3.83921,9.997669 8.57553,9.997669 4.73632,0 8.57553,-4.475868 8.57553,-9.997669 0,-5.520418 -3.83921,-9.997665 -8.57553,-9.997665"
        id="path10315"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -128.07212,-18.638346 c -0.82406,-1.411111 -1.30638,-3.128148 -1.30638,-4.980231 0,-1.850704 0.48232,-3.56774 1.30638,-4.978851 v 9.959082"
        id="path10317"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -126.22968,-30.791265 c 0.47404,-0.39274 0.98943,-0.719335 1.53651,-0.970139 v 16.287034 c -0.54708,-0.250804 -1.06247,-0.577399 -1.53651,-0.970139 v -14.346756"
        id="path10319"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -122.85073,-32.287815 c 0.25218,-0.03168 0.50712,-0.04823 0.76619,-0.04823 0.26045,0 0.51814,0.01655 0.7717,0.04823 v 17.339856 c -0.25356,0.03168 -0.51125,0.04823 -0.7717,0.04823 -0.25907,0 -0.51401,-0.01654 -0.76619,-0.04823 v -17.339856"
        id="path10321"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -119.47178,-31.758649 c 0.54846,0.250804 1.06385,0.578778 1.53789,0.971518 v 14.338487 c -0.47404,0.392741 -0.98943,0.720715 -1.53789,0.971518 v -16.281523"
        id="path10323"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -116.09145,-28.58778 c 0.81993,1.409732 1.30087,3.122634 1.30087,4.969203 0,1.847949 -0.48094,3.560851 -1.30087,4.970586 v -9.939789"
        id="path10325"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -129.94211,-23.618577 c 0,-2.291676 0.70417,-4.389049 1.86999,-6.008246 v 0.54708 c -0.9784,1.513089 -1.56131,3.406511 -1.56131,5.461166 0,2.056035 0.58291,3.950836 1.56131,5.462545 v 0.547081 c -1.16582,-1.619194 -1.86999,-3.71657 -1.86999,-6.009626"
        id="path10327"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -116.09145,-18.164301 c 0.97565,-1.511709 1.55718,-3.400996 1.55718,-5.454276 0,-2.050521 -0.58153,-3.941187 -1.55718,-5.452896 v -0.547081 c 1.16168,1.617818 1.86448,3.712436 1.86448,5.999977 0,2.288921 -0.7028,4.383539 -1.86448,6.001357 v -0.547081"
        id="path10329"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#c31d24"
        fillOpacity={1}
        d="m -113.72674,-14.666841 c 0.0579,-0.25218 0.17777,-0.508494 0.31557,-0.713821 -0.17776,-0.08682 -0.32659,-0.152965 -0.48093,-0.286632 0.33899,-0.512632 0.42443,-0.86541 0.47956,-1.482771 l -0.0234,-3.494705 c -0.22462,1.016992 -0.76757,2.349557 -1.2361,3.045464 -0.13643,0.203951 -0.19568,0.333488 -0.28112,0.46991 -0.0482,0.07717 -0.32384,0.531926 -0.31695,1.087276 -0.19292,0.03858 -0.36793,0.03168 -0.59118,0.01517 0.0276,0.242535 0.0414,0.275608 -0.0207,0.672483 -0.84887,0.06615 -1.09554,0.573264 -2.09875,1.116213 -0.49058,0.265959 -0.80891,0.387227 -1.5434,0.654569 1.706,-0.02067 2.96002,0.221862 4.03213,-0.498853 0.12265,0.16123 0.2136,0.318329 0.29353,0.507118 0.14745,-0.115753 0.43821,-0.257693 0.67799,-0.319704 0.27699,0.271473 0.6463,0.377585 1.12035,0.334863 0.0675,-0.380337 -0.0276,-0.848871 -0.3266,-1.106565"
        id="path10331"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -113.59858,-15.31314 c -0.13229,0.05512 -0.75379,0.283876 -0.75379,0.283876 l -0.01,0.0096 c -0.003,-0.05512 -0.0166,-0.108864 -0.0386,-0.15985 l -0.004,-0.01242 c 0.23977,-0.141937 0.39136,-0.345888 0.39549,-0.377582 -0.003,-0.0014 -0.003,-0.0041 -0.001,-0.0028 0.001,0 0.001,0.0014 0.001,0.0028 0.0193,0.02755 0.22462,0.217731 0.41066,0.256314"
        id="path10333"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -114.11259,-18.264899 c 0.62425,-1.382169 0.4768,-1.321537 0.61461,-1.894801 -0.0179,0.275607 -0.0358,0.624251 -0.0744,0.876434 -0.27285,1.506195 -0.66284,2.61965 -1.13275,3.850238 0,0 -0.12953,-0.01101 -0.1943,0.0014 -0.11438,-0.130913 -0.15021,-0.312812 -0.15021,-0.312812 -0.21773,-0.906752 0.46165,-1.471746 0.93707,-2.520435"
        id="path10335"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -115.67529,-15.840928 0.58292,0.486446 0.001,0.0041 c -0.0179,0.01379 -0.0345,0.02755 -0.051,0.0441 -0.0289,0.02893 -0.0537,0.06201 -0.073,0.09646 l -0.004,0.0083 c -0.29628,-0.144695 -0.49472,-0.150206 -0.49472,-0.150206 0.0744,-0.321084 0.0386,-0.489204 0.0386,-0.489204"
        id="path10337"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -118.32249,-13.743554 c -0.29215,0.06614 -0.52917,0.06339 -0.71383,0.07166 l 0.62012,-0.192927 c 1.34496,-0.504363 1.6881,-1.28433 2.59622,-1.302247 0.21222,0.0014 0.38585,0.05788 0.54433,0.146074 l 0.001,0.0248 c -0.007,0.05788 -0.001,0.117133 0.0152,0.173633 l 0.001,0.0083 c -0.62839,0.31144 -2.06155,0.840606 -3.06476,1.070737"
        id="path10339"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -115.12683,-13.784897 c -0.0358,-0.09508 -0.0854,-0.252179 -0.22462,-0.40514 0.18742,-0.158475 0.226,-0.243914 0.28802,-0.399634 l 0.005,0.0028 c 0.0593,0.03443 0.12402,0.05512 0.19017,0.06063 l 0.007,-0.0014 -0.26596,0.742763"
        id="path10341"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -115.00694,-14.796374 c -0.10335,-0.103353 -0.10197,-0.271476 0.001,-0.374826 0.10336,-0.103354 0.27286,-0.103354 0.37621,0 0.10335,0.104729 0.10197,0.272849 -0.001,0.376202 -0.10473,0.103353 -0.27285,0.101974 -0.37621,-0.0014"
        id="path10343"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -114.42954,-14.052235 c -0.13643,-0.159851 -0.19568,-0.282497 -0.24667,-0.498849 0.0675,-0.0193 0.14745,-0.06064 0.19568,-0.128157 l 0.93018,0.945331 c -0.35278,0.03306 -0.6587,-0.05099 -0.87919,-0.318325"
        id="path10345"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#c31d24"
        fillOpacity={1}
        d="m -113.40014,-33.690657 c -0.47405,-0.0441 -0.84336,0.06339 -1.12035,0.336243 -0.23978,-0.06201 -0.53054,-0.205328 -0.67799,-0.322464 -0.0799,0.190172 -0.17088,0.347268 -0.29353,0.508498 -1.07211,-0.720715 -2.32613,-0.47818 -4.03213,-0.498849 0.73449,0.267338 1.05282,0.388605 1.5434,0.654568 1.00321,0.542946 1.24988,1.050064 2.09875,1.11621 0.062,0.396875 0.0482,0.429948 0.0207,0.672483 0.22325,-0.01655 0.39826,-0.02342 0.59118,0.01517 -0.007,0.55535 0.26872,1.008722 0.31695,1.088651 0.0854,0.135047 0.14469,0.264584 0.28112,0.468532 0.46853,0.69591 1.01148,2.028472 1.2361,3.045463 l 0.0234,-3.494705 c -0.0551,-0.618737 -0.14057,-0.970139 -0.47956,-1.482767 0.15434,-0.133671 0.30317,-0.199817 0.48093,-0.286632 -0.1378,-0.205327 -0.25769,-0.463021 -0.31557,-0.713825 0.29904,-0.257693 0.39412,-0.726224 0.3266,-1.106565"
        id="path10347"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -113.59858,-31.937793 c -0.13229,-0.05512 -0.75379,-0.283877 -0.75379,-0.283877 l -0.01,-0.0096 c -0.003,0.05512 -0.0166,0.108863 -0.0386,0.159854 l -0.004,0.01101 c 0.23977,0.144692 0.39136,0.347264 0.39549,0.378958 -0.003,0.0028 -0.003,0.0041 -0.001,0.0028 0.001,0 0.001,-0.0014 0.001,-0.0028 0.0193,-0.02755 0.22462,-0.217728 0.41066,-0.256314"
        id="path10349"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -114.11259,-28.986034 c 0.62425,1.380793 0.4768,1.321537 0.61461,1.894801 -0.0179,-0.276983 -0.0358,-0.625627 -0.0744,-0.876431 -0.27285,-1.504819 -0.66284,-2.61965 -1.13275,-3.850237 0,0 -0.12953,0.01101 -0.1943,-0.0014 -0.11438,0.130912 -0.15021,0.312815 -0.15021,0.312815 -0.21773,0.906748 0.46165,1.471743 0.93707,2.520431"
        id="path10351"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -115.67529,-31.410002 0.58292,-0.486449 0.001,-0.0041 c -0.0179,-0.01379 -0.0345,-0.02755 -0.051,-0.0441 -0.0289,-0.02893 -0.0537,-0.06201 -0.073,-0.09646 l -0.004,-0.0083 c -0.29628,0.144692 -0.49472,0.150206 -0.49472,0.150206 0.0744,0.32108 0.0386,0.489204 0.0386,0.489204"
        id="path10353"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -118.32249,-33.507379 c -0.29215,-0.06615 -0.52917,-0.06339 -0.71383,-0.07166 l 0.62012,0.192924 c 1.34496,0.504362 1.6881,1.284333 2.59622,1.302247 0.21222,-0.0014 0.38585,-0.05788 0.54433,-0.146071 l 0.001,-0.02343 c -0.007,-0.05926 -0.001,-0.118512 0.0152,-0.175009 l 0.001,-0.0083 c -0.62839,-0.311436 -2.06155,-0.840603 -3.06476,-1.070737"
        id="path10355"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -115.12683,-33.466037 c -0.0358,0.09646 -0.0854,0.250804 -0.22462,0.405144 0.18742,0.158475 0.226,0.243911 0.28802,0.399631 l 0.005,-0.0028 c 0.0593,-0.03447 0.12402,-0.05512 0.19017,-0.06063 l 0.007,0.0014 -0.26596,-0.742763"
        id="path10357"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -115.00694,-32.454556 c -0.10335,0.103354 -0.10197,0.272853 0.001,0.374827 0.10336,0.104729 0.27286,0.103353 0.37621,0 0.10335,-0.104733 0.10197,-0.272853 -0.001,-0.376206 -0.10473,-0.103353 -0.27285,-0.101974 -0.37621,0.0014"
        id="path10359"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -114.42954,-33.198698 c -0.13643,0.159854 -0.19568,0.282497 -0.24667,0.498852 0.0675,0.0193 0.14745,0.06063 0.19568,0.128157 l 0.93018,-0.945335 c -0.35278,-0.03305 -0.6587,0.05099 -0.87919,0.318326"
        id="path10361"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#c31d24"
        fillOpacity={1}
        d="m -130.80339,-13.560276 c 0.47405,0.04272 0.84474,-0.06339 1.12035,-0.334864 0.24116,0.06201 0.53054,0.203952 0.67799,0.319705 0.0799,-0.188789 0.17088,-0.345888 0.29353,-0.507118 1.07349,0.720715 2.32612,0.47818 4.03214,0.498853 -0.73312,-0.267342 -1.05145,-0.38861 -1.54203,-0.654569 -1.00459,-0.54295 -1.25126,-1.050068 -2.09875,-1.116213 -0.0634,-0.396875 -0.0482,-0.429948 -0.0207,-0.672483 -0.22324,0.01655 -0.39963,0.02342 -0.59117,-0.01517 0.007,-0.55535 -0.26872,-1.010106 -0.31833,-1.087276 -0.0841,-0.136422 -0.1447,-0.265959 -0.28112,-0.46991 -0.46854,-0.695907 -1.01148,-2.028472 -1.2361,-3.045464 l -0.0234,3.494705 c 0.0551,0.617361 0.14056,0.970139 0.48094,1.482771 -0.15434,0.133667 -0.30455,0.199813 -0.48094,0.286632 0.1378,0.205327 0.25632,0.461641 0.31557,0.713821 -0.30041,0.257694 -0.39412,0.726228 -0.32797,1.106565"
        id="path10363"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -130.60495,-15.31314 c 0.13229,0.05512 0.75517,0.283876 0.75517,0.283876 l 0.008,0.0096 c 0.003,-0.05512 0.0165,-0.108864 0.04,-0.15985 l 0.003,-0.01242 c -0.23978,-0.141937 -0.39137,-0.345888 -0.39412,-0.377582 0.001,-0.0014 0.003,-0.0041 0.001,-0.0028 -0.001,0 -0.001,0.0014 -0.001,0.0028 -0.0207,0.02755 -0.22462,0.217731 -0.41204,0.256314"
        id="path10365"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -130.08956,-18.264899 c -0.62425,-1.382169 -0.47818,-1.321537 -0.61599,-1.894801 0.0179,0.275607 0.0358,0.624251 0.0758,0.876434 0.27147,1.506195 0.66283,2.61965 1.13274,3.850238 0,0 0.12816,-0.01101 0.19431,0.0014 0.113,-0.130913 0.14882,-0.312812 0.14882,-0.312812 0.21911,-0.906752 -0.46164,-1.471746 -0.93568,-2.520435"
        id="path10367"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -128.52687,-15.840928 -0.58291,0.486446 -0.003,0.0041 c 0.0179,0.01379 0.0358,0.02755 0.051,0.0441 0.0303,0.02893 0.0551,0.06201 0.0744,0.09646 l 0.003,0.0083 c 0.29766,-0.144695 0.4961,-0.150206 0.4961,-0.150206 -0.0744,-0.321084 -0.0386,-0.489204 -0.0386,-0.489204"
        id="path10369"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -125.88103,-13.743554 c 0.29352,0.06614 0.52916,0.06339 0.7152,0.07166 l -0.6215,-0.192927 c -1.34496,-0.504363 -1.68672,-1.28433 -2.59485,-1.302247 -0.21221,0.0014 -0.38722,0.05788 -0.54432,0.146074 l -0.001,0.0248 c 0.005,0.05788 0,0.117133 -0.0165,0.173633 v 0.0083 c 0.62701,0.31144 2.06017,0.840606 3.06338,1.070737"
        id="path10371"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -129.07671,-13.784897 c 0.0358,-0.09508 0.0854,-0.252179 0.22462,-0.40514 -0.18603,-0.158475 -0.22462,-0.243914 -0.28801,-0.399634 l -0.004,0.0028 c -0.0593,0.03443 -0.12403,0.05512 -0.19018,0.06063 l -0.008,-0.0014 0.26596,0.742763"
        id="path10373"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -129.19659,-14.796374 c 0.10335,-0.103353 0.10335,-0.271476 -0.001,-0.374826 -0.10335,-0.103354 -0.27147,-0.103354 -0.37482,0 -0.10336,0.104729 -0.10336,0.272849 0.001,0.376202 0.10335,0.103353 0.27147,0.101974 0.37483,-0.0014"
        id="path10375"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -129.77399,-14.052235 c 0.1378,-0.159851 0.19568,-0.282497 0.24804,-0.498849 -0.0675,-0.0193 -0.14882,-0.06064 -0.19568,-0.128157 l -0.93155,0.945331 c 0.35416,0.03306 0.66008,-0.05099 0.87919,-0.318325"
        id="path10377"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#c31d24"
        fillOpacity={1}
        d="m -130.47541,-32.584092 c -0.0593,0.250804 -0.17777,0.508497 -0.31557,0.713824 0.17638,0.08681 0.32659,0.152961 0.48093,0.286632 -0.34038,0.512629 -0.42581,0.864031 -0.48093,1.482768 l 0.0234,3.494704 c 0.22462,-1.016991 0.76757,-2.349552 1.2361,-3.045463 0.13643,-0.203948 0.19706,-0.333484 0.28112,-0.468531 0.0496,-0.07993 0.32522,-0.533301 0.31833,-1.088651 0.19155,-0.03859 0.36794,-0.03168 0.59118,-0.01517 -0.0275,-0.242534 -0.0427,-0.275607 0.0207,-0.672482 0.8475,-0.06615 1.09416,-0.573264 2.09875,-1.11621 0.49059,-0.265963 0.80891,-0.38723 1.54203,-0.654569 -1.70601,0.02067 -2.95865,-0.221865 -4.03214,0.498849 -0.12265,-0.16123 -0.2136,-0.318326 -0.29352,-0.508497 -0.14745,0.117136 -0.43684,0.260452 -0.678,0.322463 -0.27561,-0.272852 -0.6463,-0.38034 -1.12034,-0.336243 -0.0661,0.38034 0.0275,0.848872 0.32797,1.106565"
        id="path10379"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -130.60495,-31.937793 c 0.13229,-0.05512 0.75517,-0.283877 0.75517,-0.283877 l 0.008,-0.0096 c 0.003,0.05512 0.0165,0.108863 0.04,0.159854 l 0.003,0.01101 c -0.23978,0.144692 -0.39137,0.347264 -0.39412,0.378958 0.001,0.0028 0.003,0.0041 0.001,0.0028 -0.001,0 -0.001,-0.0014 -0.001,-0.0028 -0.0207,-0.02755 -0.22462,-0.217728 -0.41204,-0.256314"
        id="path10381"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -130.08956,-28.986034 c -0.62425,1.380793 -0.47818,1.321537 -0.61599,1.894801 0.0179,-0.276983 0.0358,-0.625627 0.0758,-0.876431 0.27147,-1.504819 0.66283,-2.61965 1.13274,-3.850237 0,0 0.12816,0.01101 0.19431,-0.0014 0.113,0.130912 0.14882,0.312815 0.14882,0.312815 0.21911,0.906748 -0.46164,1.471743 -0.93568,2.520431"
        id="path10383"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -128.52687,-31.410002 -0.58291,-0.486449 -0.003,-0.0041 c 0.0179,-0.01379 0.0358,-0.02755 0.051,-0.0441 0.0303,-0.02893 0.0551,-0.06201 0.0744,-0.09646 l 0.003,-0.0083 c 0.29766,0.144692 0.4961,0.150206 0.4961,0.150206 -0.0744,0.32108 -0.0386,0.489204 -0.0386,0.489204"
        id="path10385"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -125.88103,-33.507379 c 0.29352,-0.06615 0.52916,-0.06339 0.7152,-0.07166 l -0.6215,0.192924 c -1.34496,0.504362 -1.68672,1.284333 -2.59485,1.302247 -0.21221,-0.0014 -0.38722,-0.05788 -0.54432,-0.146071 l -0.001,-0.02343 c 0.005,-0.05926 0,-0.118512 -0.0165,-0.175009 v -0.0083 c 0.62701,-0.311436 2.06017,-0.840603 3.06338,-1.070737"
        id="path10387"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -129.07671,-33.466037 c 0.0358,0.09646 0.0854,0.250804 0.22462,0.405144 -0.18603,0.158475 -0.22462,0.243911 -0.28801,0.399631 l -0.004,-0.0028 c -0.0593,-0.03447 -0.12403,-0.05512 -0.19018,-0.06063 l -0.008,0.0014 0.26596,-0.742763"
        id="path10389"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -129.19659,-32.454556 c 0.10335,0.103354 0.10335,0.272853 -0.001,0.374827 -0.10335,0.104729 -0.27147,0.103353 -0.37482,0 -0.10336,-0.104733 -0.10336,-0.272853 0.001,-0.376206 0.10335,-0.103353 0.27147,-0.101974 0.37483,0.0014"
        id="path10391"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -129.77399,-33.198698 c 0.1378,0.159854 0.19568,0.282497 0.24804,0.498852 -0.0675,0.0193 -0.14882,0.06063 -0.19568,0.128157 l -0.93155,-0.945335 c 0.35416,-0.03305 0.66008,0.05099 0.87919,0.318326"
        id="path10393"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -117.93389,-31.498196 v 0.389981 c -0.4768,-0.374826 -0.99219,-0.686262 -1.53789,-0.924662 v -0.338998 c 0.54295,0.226 1.05833,0.520901 1.53789,0.873679"
        id="path10395"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -122.08454,-32.898283 c 0.26045,0 0.51814,0.01517 0.7717,0.0441 v 0.314191 c -0.25356,-0.0303 -0.51125,-0.04548 -0.7717,-0.04548 -0.25907,0 -0.51401,0.01517 -0.76619,0.04548 v -0.314191 c 0.25218,-0.02893 0.50712,-0.0441 0.76619,-0.0441"
        id="path10397"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -124.69317,-32.37463 v 0.338998 c -0.54432,0.2384 -1.05971,0.54846 -1.53651,0.921907 v -0.388606 c 0.47956,-0.352778 0.99495,-0.646299 1.53651,-0.872299"
        id="path10399"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -126.22968,-15.73344 v -0.388609 c 0.4768,0.37345 0.99219,0.684886 1.53651,0.923286 v 0.337619 c -0.54156,-0.225996 -1.05695,-0.519518 -1.53651,-0.872296"
        id="path10401"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -122.08454,-14.337488 c -0.25907,0 -0.51401,-0.01517 -0.76619,-0.04272 v -0.31557 c 0.25218,0.0303 0.50712,0.04548 0.76619,0.04548 0.26045,0 0.51814,-0.01517 0.7717,-0.04548 v 0.314194 c -0.25356,0.02893 -0.51125,0.0441 -0.7717,0.0441"
        id="path10403"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -119.47178,-14.863899 v -0.337619 c 0.5457,-0.23978 1.06109,-0.551215 1.53789,-0.924666 v 0.38861 c -0.47956,0.354153 -0.99494,0.647675 -1.53789,0.873675"
        id="path10405"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -102.30142,-24.970432 c -0.58154,0.751032 -1.34359,1.036285 -2.07395,1.036285 -2.33991,0 -3.71519,-1.745975 -3.71519,-3.926029 0,-2.243448 1.37528,-3.989422 3.71519,-3.989422 1.54478,0 3.0055,0.952224 3.18465,2.666506 h -1.5875 c -0.19018,-0.836472 -0.81443,-1.270554 -1.59715,-1.270554 -1.49242,0 -2.05328,1.270554 -2.05328,2.59347 0,1.259526 0.56086,2.530077 2.05328,2.530077 1.079,0 1.70325,-0.582909 1.79834,-1.630218 h -1.67156 v -1.238857 h 3.175 v 4.084503 h -1.05833 l -0.1695,-0.855761"
        id="path10407"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -96.206362,-27.437121 c -0.136427,-0.762053 -0.464397,-1.164442 -1.19476,-1.164442 -0.952221,0 -1.227829,0.741387 -1.248502,1.164442 z m -2.443262,0.952225 c 0.04134,0.952225 0.507118,1.386307 1.34359,1.386307 0.602202,0 1.090027,-0.369312 1.185111,-0.708311 h 1.322917 c -0.423059,1.29122 -1.322917,1.841059 -2.560394,1.841059 -1.726682,0 -2.79466,-1.185114 -2.79466,-2.878723 0,-1.639866 1.132745,-2.888368 2.79466,-2.888368 1.861728,0 2.761586,1.565452 2.655478,3.248036 h -3.946702"
        id="path10409"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -93.814088,-29.585481 h 1.429025 v 0.762056 h 0.03172 c 0.380337,-0.613226 1.03766,-0.909507 1.672939,-0.909507 1.597145,0 1.99953,0.898483 1.99953,2.254472 v 3.363789 h -1.503436 v -3.08956 c 0,-0.899859 -0.264584,-1.343586 -0.963249,-1.343586 -0.814423,0 -1.163066,0.454752 -1.163066,1.565451 v 2.867695 h -1.50344 v -5.47081"
        id="path10411"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -83.855006,-27.437121 c -0.137802,-0.762053 -0.465776,-1.164442 -1.196135,-1.164442 -0.952225,0 -1.227833,0.741387 -1.248505,1.164442 z m -2.44464,0.952225 c 0.04272,0.952225 0.508497,1.386307 1.343589,1.386307 0.603582,0 1.090027,-0.369312 1.185111,-0.708311 h 1.322917 c -0.423058,1.29122 -1.322917,1.841059 -2.560394,1.841059 -1.725302,0 -2.793284,-1.185114 -2.793284,-2.878723 0,-1.639866 1.131369,-2.888368 2.793284,-2.888368 1.863107,0 2.76159,1.565452 2.656857,3.248036 h -3.94808"
        id="path10413"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -81.462732,-29.585481 h 1.42765 v 1.015615 h 0.02205 c 0.275608,-0.687641 1.015612,-1.163066 1.745975,-1.163066 0.106109,0 0.232886,0.02067 0.327971,0.05237 v 1.397331 c -0.137803,-0.03168 -0.359668,-0.05375 -0.540191,-0.05375 -1.099672,0 -1.481392,0.79375 -1.481392,1.757 v 2.465309 h -1.502061 v -5.47081"
        id="path10415"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -73.938641,-26.790818 c -0.253559,0.221862 -0.782726,0.232886 -1.249882,0.316946 -0.4644,0.09508 -0.887458,0.253559 -0.887458,0.804774 0,0.560864 0.432707,0.698666 0.920531,0.698666 1.174087,0 1.216809,-0.931552 1.216809,-1.259526 z m -3.471281,-1.112079 c 0.08406,-1.406977 1.34359,-1.830035 2.571422,-1.830035 1.090027,0 2.401919,0.242535 2.401919,1.555807 v 2.847026 c 0,0.496093 0.05374,0.993566 0.190169,1.215428 h -1.52273 c -0.05375,-0.168119 -0.09646,-0.348643 -0.106112,-0.529166 -0.476801,0.498852 -1.175466,0.677996 -1.841059,0.677996 -1.037661,0 -1.863108,-0.518142 -1.863108,-1.639866 0,-1.238857 0.931556,-1.535134 1.863108,-1.661915 0.920531,-0.137802 1.777672,-0.106108 1.777672,-0.719335 0,-0.646299 -0.445107,-0.741384 -0.974274,-0.741384 -0.570509,0 -0.9412,0.232887 -0.994943,0.825444 h -1.502064"
        id="path10417"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -71.229421,-31.670454 h 1.50344 v 7.555783 h -1.50344 v -7.555783"
        id="path10419"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -68.499524,-29.585481 h 1.503436 v 5.47081 h -1.503436 z m 1.503436,-0.846117 h -1.503436 v -1.238856 h 1.503436 v 1.238856"
        id="path10421"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -63.905148,-29.585481 h 1.099676 v 1.005967 h -1.099676 v 2.709224 c 0,0.507118 0.126781,0.635275 0.6339,0.635275 0.15985,0 0.307301,-0.01101 0.465776,-0.04272 v 1.174087 c -0.253559,0.04272 -0.581533,0.05375 -0.87781,0.05375 -0.920532,0 -1.725306,-0.21222 -1.725306,-1.302247 v -3.227366 h -0.910883 v -1.005967 h 0.910883 v -1.639867 h 1.50344 v 1.639867"
        id="path10423"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -58.678248,-26.790818 c -0.253559,0.221862 -0.782725,0.232886 -1.248501,0.316946 -0.46578,0.09508 -0.888835,0.253559 -0.888835,0.804774 0,0.560864 0.434079,0.698666 0.920528,0.698666 1.17409,0 1.216808,-0.931552 1.216808,-1.259526 z m -3.471277,-1.112079 c 0.08544,-1.406977 1.344966,-1.830035 2.571419,-1.830035 1.090027,0 2.403298,0.242535 2.403298,1.555807 v 2.847026 c 0,0.496093 0.05237,0.993566 0.190169,1.215428 h -1.52411 c -0.05237,-0.168119 -0.09508,-0.348643 -0.104732,-0.529166 -0.476801,0.498852 -1.175466,0.677996 -1.842435,0.677996 -1.036285,0 -1.861732,-0.518142 -1.861732,-1.639866 0,-1.238857 0.930176,-1.535134 1.861732,-1.661915 0.920528,-0.137802 1.777668,-0.106108 1.777668,-0.719335 0,-0.646299 -0.443727,-0.741384 -0.972894,-0.741384 -0.571888,0 -0.94258,0.232887 -0.994946,0.825444 h -1.503437"
        id="path10425"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -54.105916,-29.585481 h 1.101051 v 1.005967 h -1.101051 v 2.709224 c 0,0.507118 0.126778,0.635275 0.635275,0.635275 0.158475,0 0.305925,-0.01101 0.465776,-0.04272 v 1.174087 c -0.253559,0.04272 -0.582909,0.05375 -0.879189,0.05375 -0.920528,0 -1.725302,-0.21222 -1.725302,-1.302247 v -3.227366 h -0.909507 v -1.005967 h 0.909507 v -1.639867 h 1.50344 v 1.639867"
        id="path10427"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -105.3276,-18.01823 c -0.98529,0 -1.32291,0.847496 -1.32291,1.747354 0,0.857141 0.39136,1.75562 1.32291,1.75562 0.99357,0 1.28985,-0.868165 1.28985,-1.766644 0,-0.888834 -0.31695,-1.73633 -1.28985,-1.73633 z m 1.31189,3.789606 h -0.022 c -0.34865,0.592557 -0.96187,0.846116 -1.66054,0.846116 -1.65089,0 -2.45566,-1.418 -2.45566,-2.931089 0,-1.471743 0.8158,-2.836002 2.42397,-2.836002 0.64492,0 1.2802,0.274232 1.61919,0.814423 h 0.0207 v -2.751945 h 1.50344 v 7.555784 h -1.42903 v -0.697287"
        id="path10429"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -97.771814,-16.853788 c -0.137802,-0.762053 -0.465776,-1.164442 -1.196135,-1.164442 -0.952225,0 -1.227831,0.741387 -1.248501,1.164442 z m -2.444636,0.952225 c 0.0427,0.952225 0.508493,1.386307 1.343585,1.386307 0.603582,0 1.090027,-0.369312 1.185111,-0.708311 h 1.322917 c -0.423055,1.29122 -1.322917,1.841059 -2.560394,1.841059 -1.725299,0 -2.794659,-1.185114 -2.794659,-2.878723 0,-1.639866 1.13274,-2.888368 2.794659,-2.888368 1.863107,0 2.76159,1.565452 2.656857,3.248036 h -3.948076"
        id="path10431"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -87.240843,-18.547396 c -0.106112,-0.751029 -0.825447,-1.322917 -1.650891,-1.322917 -1.493795,0 -2.053276,1.270554 -2.053276,2.59347 0,1.259526 0.559481,2.530077 2.053276,2.530077 1.015612,0 1.586121,-0.698666 1.712902,-1.693609 h 1.609548 c -0.169499,1.883777 -1.471746,3.089561 -3.32245,3.089561 -2.339908,0 -3.715191,-1.745975 -3.715191,-3.926029 0,-2.243447 1.375283,-3.989422 3.715191,-3.989422 1.660536,0 3.057867,0.972894 3.25906,2.718869 h -1.608169"
        id="path10433"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -81.1885,-16.207485 c -0.253559,0.221862 -0.782725,0.232886 -1.248505,0.316946 -0.465776,0.09508 -0.888834,0.253559 -0.888834,0.804774 0,0.560864 0.434082,0.698666 0.920531,0.698666 1.175466,0 1.216808,-0.931552 1.216808,-1.259526 z m -3.47128,-1.112079 c 0.08544,-1.406976 1.344965,-1.830035 2.572798,-1.830035 1.090026,0 2.401919,0.242535 2.401919,1.555807 v 2.847026 c 0,0.496093 0.05237,0.993567 0.190172,1.215429 h -1.524113 c -0.05236,-0.16812 -0.09508,-0.348644 -0.106109,-0.529167 -0.475421,0.498852 -1.174086,0.677996 -1.841059,0.677996 -1.03766,0 -1.863107,-0.518142 -1.863107,-1.639866 0,-1.238857 0.931555,-1.535134 1.863107,-1.661915 0.920532,-0.137802 1.777672,-0.106108 1.777672,-0.719335 0,-0.646299 -0.443731,-0.741384 -0.972897,-0.741384 -0.571885,0 -0.942577,0.232887 -0.994943,0.825444 h -1.50344"
        id="path10435"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -76.616172,-19.002148 h 1.101055 v 1.005967 h -1.101055 v 2.709224 c 0,0.507118 0.126781,0.635275 0.635275,0.635275 0.158475,0 0.307305,-0.01101 0.46578,-0.04272 v 1.174087 c -0.253559,0.04272 -0.582912,0.05375 -0.879189,0.05375 -0.920532,0 -1.723927,-0.212221 -1.723927,-1.302248 v -3.227366 h -0.910882 v -1.005967 h 0.910882 v -1.639866 h 1.502061 v 1.639866"
        id="path10437"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -71.387892,-16.207485 c -0.254939,0.221862 -0.784105,0.232886 -1.248506,0.316946 -0.465776,0.09508 -0.89021,0.253559 -0.89021,0.804774 0,0.560864 0.435459,0.698666 0.921907,0.698666 1.174087,0 1.216809,-0.931552 1.216809,-1.259526 z m -3.471281,-1.112079 c 0.08406,-1.406976 1.34359,-1.830035 2.571419,-1.830035 1.09003,0 2.401922,0.242535 2.401922,1.555807 v 2.847026 c 0,0.496093 0.05374,0.993567 0.191548,1.215429 h -1.524113 c -0.05374,-0.16812 -0.09508,-0.348644 -0.106108,-0.529167 -0.476801,0.498852 -1.174087,0.677996 -1.841059,0.677996 -1.037661,0 -1.863108,-0.518142 -1.863108,-1.639866 0,-1.238857 0.931556,-1.535134 1.863108,-1.661915 0.920531,-0.137802 1.777672,-0.106108 1.777672,-0.719335 0,-0.646299 -0.445107,-0.741384 -0.974274,-0.741384 -0.571888,0 -0.9412,0.232887 -0.993567,0.825444 h -1.50344"
        id="path10439"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -68.678672,-21.087121 h 1.502064 v 7.555784 h -1.502064 v -7.555784"
        id="path10441"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -60.858305,-13.531337 h -1.427646 v -0.760678 h -0.03171 c -0.381717,0.613227 -1.037661,0.909507 -1.672936,0.909507 -1.598524,0 -1.999534,-0.899858 -1.999534,-2.254472 v -3.365168 h 1.502061 v 3.09094 c 0,0.899858 0.264583,1.343586 0.963249,1.343586 0.815798,0 1.164442,-0.454752 1.164442,-1.566827 v -2.867699 h 1.50206 v 5.470811"
        id="path10443"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -59.714532,-19.002148 h 1.429025 v 0.762056 h 0.03168 c 0.38034,-0.613226 1.036285,-0.909507 1.671564,-0.909507 1.598524,0 2.000909,0.898483 2.000909,2.254473 v 3.363789 h -1.50344 v -3.089561 c 0,-0.899859 -0.264583,-1.343586 -0.963249,-1.343586 -0.814419,0 -1.163062,0.454752 -1.163062,1.565451 v 2.867696 h -1.503441 v -5.470811"
        id="path10445"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -50.740748,-12.842317 c -0.327974,0.87781 -0.846116,1.237478 -1.883777,1.237478 -0.307304,0 -0.61323,-0.02067 -0.920531,-0.05237 v -1.238856 c 0.286632,0.02205 0.581533,0.06339 0.87781,0.05375 0.519522,-0.05375 0.689021,-0.592557 0.519522,-1.026639 l -1.926499,-5.133192 h 1.609549 l 1.237477,3.746884 h 0.02067 l 1.196135,-3.746884 h 1.555807 l -2.286166,6.159831"
        id="path10447"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -44.538199,-16.207485 c -0.253559,0.221862 -0.782725,0.232886 -1.249881,0.316946 -0.464396,0.09508 -0.887454,0.253559 -0.887454,0.804774 0,0.560864 0.432703,0.698666 0.920527,0.698666 1.174091,0 1.216808,-0.931552 1.216808,-1.259526 z m -3.471276,-1.112079 c 0.08406,-1.406976 1.343586,-1.830035 2.571418,-1.830035 1.090027,0 2.401919,0.242535 2.401919,1.555807 v 2.847026 c 0,0.496093 0.05375,0.993567 0.190172,1.215429 h -1.522733 c -0.05374,-0.16812 -0.09646,-0.348644 -0.106109,-0.529167 -0.4768,0.498852 -1.17409,0.677996 -1.841059,0.677996 -1.037664,0 -1.863107,-0.518142 -1.863107,-1.639866 0,-1.238857 0.931552,-1.535134 1.863107,-1.661915 0.920528,-0.137802 1.777668,-0.106108 1.777668,-0.719335 0,-0.646299 -0.445106,-0.741384 -0.974273,-0.741384 -0.571884,0 -0.9412,0.232887 -0.994943,0.825444 h -1.50206"
        id="path10449"
        style={{
          strokeWidth: 0.352778,
        }}
      />
    </g>
  </svg>
);
export default SVGComponent;
